/**
 * TrueLineWellness — search.js
 * <search-modal>: header search with Shopify Predictive Search
 * (/search/suggest?section_id=predictive-search). Pressing Enter goes to the
 * full /search results page; ↑/↓ move through product suggestions.
 */
(function () {
  'use strict';

  var TLW = (window.TLW = window.TLW || {});
  var theme = window.theme || {};
  var routes = theme.routes || {};
  var ui = TLW.ui;

  if (customElements.get('search-modal')) return;

  customElements.define('search-modal', class extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-search-results]');
      this.cache = new Map();
      this.addEventListener('click', (e) => { if (e.target.closest('[data-search-close]')) this.close(); });
      this.input.addEventListener('input', ui.debounce(() => this.search(), 180));
      this.input.addEventListener('keydown', (e) => this.onKeydown(e));
      this.onDocKey = (e) => {
        if (e.key === 'Escape' && this.isOpen) this.close();
        if (e.key === '/' && !this.isOpen && !/input|textarea|select/i.test(document.activeElement.tagName) && !document.activeElement.isContentEditable) {
          e.preventDefault();
          this.open();
        }
      };
      document.addEventListener('keydown', this.onDocKey);
    }
    disconnectedCallback() {
      document.removeEventListener('keydown', this.onDocKey);
      this._bound = false;
    }

    get isOpen() { return this.classList.contains('is-open'); }

    open(trigger) {
      if (this.isOpen) return;
      this.returnFocus = trigger || document.activeElement;
      this.removeAttribute('inert');
      this.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => this.classList.add('is-open'));
      document.querySelectorAll('[data-search-open]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
      ui.lockScroll();
      this.release = ui.trapFocus(this.querySelector('.search-modal__panel'), this.input);
    }

    close() {
      if (!this.isOpen) return;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      this.setAttribute('inert', '');
      document.querySelectorAll('[data-search-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      ui.unlockScroll();
      if (this.release) this.release();
      if (this.returnFocus && this.returnFocus.focus) this.returnFocus.focus({ preventScroll: true });
    }

    search() {
      const q = this.input.value.trim();
      if (!q) {
        this.results.innerHTML = '';
        this.input.setAttribute('aria-expanded', 'false');
        return;
      }
      const url = (routes.predictiveSearch || '/search/suggest') +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last' +
        '&section_id=predictive-search';
      const render = (html) => {
        if (this.input.value.trim() !== q) return; // stale response
        const inner = ui.parseSection(html, '#shopify-section-predictive-search') || ui.parseSection(html, '.shopify-section');
        this.results.innerHTML = inner || '';
        this.input.setAttribute('aria-expanded', inner ? 'true' : 'false');
        this.activeIndex = -1;
      };
      if (this.cache.has(url)) return render(this.cache.get(url));
      fetch(url)
        .then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then((html) => { this.cache.set(url, html); render(html); })
        .catch(() => { this.results.innerHTML = ''; });
    }

    onKeydown(e) {
      const options = Array.from(this.results.querySelectorAll('[role="option"]'));
      if (!options.length || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter')) return;
      if (e.key === 'Enter') {
        if (this.activeIndex > -1 && options[this.activeIndex]) {
          e.preventDefault();
          options[this.activeIndex].querySelector('a').click();
        }
        return;
      }
      e.preventDefault();
      this.activeIndex = typeof this.activeIndex === 'number' ? this.activeIndex : -1;
      this.activeIndex = e.key === 'ArrowDown'
        ? Math.min(options.length - 1, this.activeIndex + 1)
        : Math.max(0, this.activeIndex - 1);
      options.forEach((o, i) => {
        const active = i === this.activeIndex;
        o.setAttribute('aria-selected', active ? 'true' : 'false');
        o.querySelector('a').classList.toggle('is-active', active);
      });
      this.input.setAttribute('aria-activedescendant', options[this.activeIndex].id);
      options[this.activeIndex].scrollIntoView({ block: 'nearest' });
    }
  });

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-search-open]');
    if (!t) return;
    const modal = document.getElementById('SearchModal');
    if (modal && typeof modal.open === 'function') {
      e.preventDefault();
      modal.open(t);
    }
  });
})();
